
import { useScroll, useTransform } from "framer-motion";
import SafeMotion from '@/components/motion/SafeMotion';
import MotionErrorBoundary from '@/components/motion/MotionErrorBoundary';

const ParallaxBackground = () => {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 1000], [0, -200]);
  const y2 = useTransform(scrollY, [0, 1000], [0, -100]);
  const y3 = useTransform(scrollY, [0, 1000], [0, -300]);
  const rotate1 = useTransform(scrollY, [0, 1000], [0, 360]);
  const rotate2 = useTransform(scrollY, [0, 1000], [0, -180]);

  return (
    <MotionErrorBoundary>
      <SafeMotion 
        className="fixed top-0 left-0 w-[50vw] h-[50vw] max-w-[600px] max-h-[600px] bg-gradient-to-br from-blue-500/15 via-purple-500/10 to-pink-500/5 rounded-full blur-3xl pointer-events-none -z-10"
        style={{ 
          y: y1, 
          rotate: rotate1,
          transform: 'translate3d(0,0,0)',
          WebkitTransform: 'translate3d(0,0,0)',
          willChange: 'transform',
          contain: 'layout style paint'
        }}
        aria-hidden="true"
        fallback={
          <div 
            className="fixed top-0 left-0 w-[50vw] h-[50vw] max-w-[600px] max-h-[600px] bg-gradient-to-br from-blue-500/15 via-purple-500/10 to-pink-500/5 rounded-full blur-3xl pointer-events-none -z-10" 
            aria-hidden="true"
            style={{ 
              transform: 'translate3d(0,0,0)',
              WebkitTransform: 'translate3d(0,0,0)',
              willChange: 'transform',
              contain: 'layout style paint'
            }}
          />
        }
      >
        <div />
      </SafeMotion>
      <SafeMotion 
        className="fixed bottom-0 right-0 w-[40vw] h-[40vw] max-w-[500px] max-h-[500px] bg-gradient-to-br from-amber-500/12 via-orange-500/8 to-red-500/5 rounded-full blur-3xl pointer-events-none -z-10"
        style={{ 
          y: y2, 
          rotate: rotate2,
          transform: 'translate3d(0,0,0)',
          WebkitTransform: 'translate3d(0,0,0)',
          willChange: 'transform',
          contain: 'layout style paint'
        }}
        aria-hidden="true"
        fallback={
          <div 
            className="fixed bottom-0 right-0 w-[40vw] h-[40vw] max-w-[500px] max-h-[500px] bg-gradient-to-br from-amber-500/12 via-orange-500/8 to-red-500/5 rounded-full blur-3xl pointer-events-none -z-10" 
            aria-hidden="true"
            style={{ 
              transform: 'translate3d(0,0,0)',
              WebkitTransform: 'translate3d(0,0,0)',
              willChange: 'transform',
              contain: 'layout style paint'
            }}
          />
        }
      >
        <div />
      </SafeMotion>
      <SafeMotion 
        className="fixed top-1/2 left-1/3 w-[30vw] h-[30vw] max-w-[300px] max-h-[300px] bg-gradient-to-br from-green-500/10 via-cyan-500/8 to-blue-500/5 rounded-full blur-2xl pointer-events-none -z-10"
        style={{ 
          y: y3,
          transform: 'translate3d(0,0,0)',
          WebkitTransform: 'translate3d(0,0,0)',
          willChange: 'transform',
          contain: 'layout style paint'
        }}
        aria-hidden="true"
        fallback={
          <div 
            className="fixed top-1/2 left-1/3 w-[30vw] h-[30vw] max-w-[300px] max-h-[300px] bg-gradient-to-br from-green-500/10 via-cyan-500/8 to-blue-500/5 rounded-full blur-2xl pointer-events-none -z-10" 
            aria-hidden="true"
            style={{ 
              transform: 'translate3d(0,0,0)',
              WebkitTransform: 'translate3d(0,0,0)',
              willChange: 'transform',
              contain: 'layout style paint'
            }}
          />
        }
      >
        <div />
      </SafeMotion>
    </MotionErrorBoundary>
  );
};

export default ParallaxBackground;
